module.exports = __webpack_public_path__ + "static/media/athletic-person-running-svgrepo-com.b966657d.svg";